import { ref, computed } from "vue";
import { useToast } from "vue-toastification"

import store from "../state/store"
import useSortData from './useSortData';


export default function useValues(props, emit, valueData) {

    // Get toast interface
    const toast = useToast()

    const search = ref("")
    const attributeId = ref("")
    const perPage = ref(10)
    const loading = ref(false)
    const errors = ref({})


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getValues = (url = null) => {
        store.dispatch("getValues", {
            url,
            search: search.value,
            attributeId: attributeId.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }

    const onSubmit = () => {
        loading.value = true
        if (valueData.value.id) {
            store.dispatch('updateValue', valueData.value)
                .then(response => {
                    loading.value = false;
                    if (response.status === 200) {
                        toast.success("ویژگی مورد نظر با موفقیت به روزرسانی شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getValues")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })

        } else {
            store
                .dispatch("createValue", valueData.value)
                .then((response) => {
                    loading.value = false
                    if (response.status === 201) {
                        toast.success(" ویژگی مورد نظر با موفقیت افزوده شد!", {
                            timeout: 3000,
                        })
                        store.dispatch("getValues")
                        closeModal()
                    }
                })
                .catch((err) => {
                    loading.value = false
                    errors.value = err.response.data.errors
                })
        }
    }


    const closeModal = () => {
        show.value = false
        errors.value = {}
        emit("close")
    }

    const { sortField, sortDirection, sortData } = useSortData(getValues);

    const sortValues = (field) => {
        sortData(field);
        getValues();
    };


    return {
        show,
        search,
        attributeId,
        perPage,
        sortField,
        sortDirection,
        loading,
        errors,
        getValues,
        onSubmit,
        closeModal,
        sortValues,
    }
}